import { combineReducers } from 'redux';
import trailsReducer from "./trailsReducer";
import pageReducer from './pageReducers';

export const rootReducer = combineReducers({
  trails: trailsReducer,
  pages: pageReducer
});

export type AppState = ReturnType<typeof rootReducer>;